let timer: NodeJS.Timeout
const Debounce = ({
  func,
  timeout,
}: {
  func: () => void
  timeout?: number
}) => {
  timer && clearTimeout(timer)

  timer = setTimeout(() => {
    func()
  }, timeout)
  return <></>
}

export default Debounce
